import { PUBLIC_PHONE_LINK, WHATSAPP_URL } from "@/lib/contact";

const TAIF_HOURS = {
  ar: [
    "الاثنين - الخميس: 8:00 AM - 10:30 PM",
    "الجمعة: 8:30 AM - 10:30 PM",
    "السبت: 8:00 AM - 10:30 PM",
    "الأحد: مغلق",
  ],
  en: [
    "Monday - Thursday: 8:00 AM - 10:30 PM",
    "Friday: 8:30 AM - 10:30 PM",
    "Saturday: 8:00 AM - 10:30 PM",
    "Sunday: Closed",
  ],
};

const MAKKAH_HOURS = {
  ar: [
    "الأحد: 8:00 AM - 10:00 PM",
    "الاثنين: 8:00 AM - 10:00 PM",
    "الثلاثاء: 8:00 AM - 10:00 PM",
    "الأربعاء: 8:00 AM - 10:00 PM",
    "الخميس: 8:00 AM - 10:00 PM",
    "الجمعة: مغلق",
    "السبت: 8:00 AM - 10:00 PM",
  ],
  en: [
    "Sunday: 8:00 AM - 10:00 PM",
    "Monday: 8:00 AM - 10:00 PM",
    "Tuesday: 8:00 AM - 10:00 PM",
    "Wednesday: 8:00 AM - 10:00 PM",
    "Thursday: 8:00 AM - 10:00 PM",
    "Friday: Closed",
    "Saturday: 8:00 AM - 10:00 PM",
  ],
};

export const BRANCHES = [
  {
    id: "taif",
    order: "01",
    name: {
      ar: "فرع الطائف",
      en: "Taif Branch",
    },
    city: {
      ar: "الطائف",
      en: "Taif",
    },
    coordinates: {
      lat: 21.2703,
      lng: 40.4158,
    },
    phone_display: "+966 50 733 6999",
    phone_link: PUBLIC_PHONE_LINK,
    whatsapp_url: WHATSAPP_URL,
    map_url: "https://maps.app.goo.gl/SJveZ6GHGwE7Zr41A",
    address: {
      ar: [
        "طريق الملك فيصل",
        "حي مشتى بالقرب من الطائف",
        "المملكة العربية السعودية",
      ],
      en: [
        "King Faisal Road",
        "Mashta district, near central Taif",
        "Saudi Arabia",
      ],
    },
    note: {
      ar: "الفرع الرئيسي لخدمة عملاء المنطقة الغربية ومتابعة فرص البيع والاستثمار.",
      en: "The main western region branch for residential and investment advisory.",
    },
    hours: TAIF_HOURS,
    approximate_map_position: false,
  },
  {
    id: "makkah",
    order: "02",
    name: {
      ar: "فرع مكة",
      en: "Makkah Branch",
    },
    city: {
      ar: "مكة المكرمة",
      en: "Makkah",
    },
    coordinates: {
      lat: 21.3259043,
      lng: 39.6842642,
    },
    phone_display: "+966 50 733 6999",
    phone_link: PUBLIC_PHONE_LINK,
    whatsapp_url: WHATSAPP_URL,
    map_url:
      "https://www.google.com/maps/place/%D8%A7%D8%B9%D9%85%D8%A7%D9%84+%D8%A7%D9%84%D8%B9%D9%82%D8%A7%D8%B1+%D9%81%D8%B1%D8%B9+%D9%85%D9%83%D8%A9%E2%80%AD/@21.3259043,39.6868338,1229m/data=!3m2!1e3!4b1!4m6!3m5!1s0x15c217bc6d4a03db:0x2c91121173632dcc!8m2!3d21.3259043!4d39.6842642!16s%2Fg%2F11rpyqkm_n?entry=ttu",
    address: {
      ar: [
        "جامع، ولي العهد 1",
        "8MGM+9M",
        "مكة 24567",
        "المملكة العربية السعودية",
      ],
      en: [
        "Jami, Wali Al Ahd 1",
        "8MGM+9M",
        "Makkah 24567",
        "Saudi Arabia",
      ],
    },
    note: {
      ar: "فرع مكة في حي ولي العهد لخدمة العملاء ومعاينات العقارات ضمن نطاق العاصمة المقدسة.",
      en: "The Makkah branch in Wali Al Ahd serves local clients and property viewings across the holy city.",
    },
    hours: MAKKAH_HOURS,
    approximate_map_position: false,
  },
];
